import { joinPath } from './joinPath';
export function getAuthRedirectUrl(basePath) {
    if (basePath === void 0) { basePath = ''; }
    return joinPath(window.location.origin, basePath, 'auth');
}
